import React from 'react';
import { Target, LayoutDashboard, BarChart2, Wrench, Database, MessageSquare, Users, Bot, Settings, RefreshCw, Sun, Moon, LogOut, ChevronLeft, ChevronRight } from 'lucide-react';

export default function AdminSidebar({
  sidebarExpanded,
  toggleSidebar,
  activeDashboardSection,
  setActiveDashboardSection,
  handleManualSync,
  theme,
  toggleTheme,
  handleLogout,
}) {
  return (
    <aside className={`admin-sidebar ${sidebarExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="admin-sidebar__brand" style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '0.25rem 0', overflow: 'hidden', width: '100%' }}>
        <div 
          style={{ 
            display: 'grid', 
            placeItems: 'center', 
            width: '32px', 
            height: '32px', 
            borderRadius: '8px', 
            background: 'linear-gradient(135deg, rgba(116, 242, 255, 0.2) 0%, rgba(216, 255, 62, 0.1) 100%)', 
            border: '1px solid rgba(116, 242, 255, 0.3)',
            color: 'var(--accent)',
            boxShadow: '0 0 12px rgba(116, 242, 255, 0.2)',
            flexShrink: 0
          }}
        >
          <Target size={18} />
        </div>
        <span className="admin-sidebar__brand-text" style={{ fontSize: '1.15rem', fontWeight: 800, letterSpacing: '-0.03em', color: 'var(--text-primary)' }}>
          LeadsZone <span style={{ color: 'var(--accent)' }}>Maps</span>
        </span>
      </div>

      <nav className="admin-sidebar__nav">
        <button
          className={`admin-sidebar__tab ${activeDashboardSection === 'dashboard-overview' ? 'active' : ''}`}
          onClick={() => setActiveDashboardSection('dashboard-overview')}
          title="Dashboard Principal"
        >
          <LayoutDashboard size={18} />
          <span className="admin-sidebar__tab-text">Painel</span>
        </button>

        <button
          className={`admin-sidebar__tab ${activeDashboardSection === 'analytics' ? 'active' : ''}`}
          onClick={() => setActiveDashboardSection('analytics')}
          title="Dashboard Analytics"
        >
          <BarChart2 size={18} />
          <span className="admin-sidebar__tab-text">Analytics</span>
        </button>
        
        <button
          className={`admin-sidebar__tab ${activeDashboardSection === 'config' ? 'active' : ''}`}
          onClick={() => setActiveDashboardSection('config')}
          title="Configuração"
        >
          <Wrench size={18} />
          <span className="admin-sidebar__tab-text">Configuração</span>
        </button>

        <button
          className={`admin-sidebar__tab ${activeDashboardSection === 'base' ? 'active' : ''}`}
          onClick={() => setActiveDashboardSection('base')}
          title="Base de Leads"
        >
          <Database size={18} />
          <span className="admin-sidebar__tab-text">Base</span>
        </button>

        <button
          className={`admin-sidebar__tab ${activeDashboardSection === 'requests' ? 'active' : ''}`}
          onClick={() => setActiveDashboardSection('requests')}
          title="Solicitações"
        >
          <MessageSquare size={18} />
          <span className="admin-sidebar__tab-text">Solicitações</span>
        </button>

        <button
          className={`admin-sidebar__tab ${activeDashboardSection === 'clients' ? 'active' : ''}`}
          onClick={() => setActiveDashboardSection('clients')}
          title="Clientes"
        >
          <Users size={18} />
          <span className="admin-sidebar__tab-text">Clientes</span>
        </button>

        <button
          className={`admin-sidebar__tab ${activeDashboardSection === 'ai-agents' ? 'active' : ''}`}
          onClick={() => setActiveDashboardSection('ai-agents')}
          title="Agentes de IA"
        >
          <Bot size={18} />
          <span className="admin-sidebar__tab-text">Agentes de IA</span>
        </button>

        <button
          className={`admin-sidebar__tab ${activeDashboardSection === 'settings' ? 'active' : ''}`}
          onClick={() => setActiveDashboardSection('settings')}
          title="Ajustes de Conta"
        >
          <Settings size={18} />
          <span className="admin-sidebar__tab-text">Ajustes</span>
        </button>
      </nav>

      <div className="admin-sidebar__footer">
        <button className="admin-sidebar__tab" onClick={handleManualSync} title="Sincronizar dados">
          <RefreshCw size={18} />
          <span className="admin-sidebar__tab-text">Sincronizar</span>
        </button>
        
        <button className="admin-sidebar__tab" onClick={toggleTheme} title="Alternar tema">
          {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
          <span className="admin-sidebar__tab-text">Tema</span>
        </button>

        <a
          href="https://www.whatszone.app.br"
          target="_blank"
          rel="noreferrer"
          className="admin-sidebar__tab"
          style={{ color: 'var(--accent)', fontWeight: 700, textDecoration: 'none' }}
          title="WhatsZone App"
        >
          <span style={{ fontSize: '18px', display: 'inline-block', lineHeight: 1 }}>🚀</span>
          <span className="admin-sidebar__tab-text">WhatsZone</span>
        </a>

        <button className="admin-sidebar__tab" onClick={handleLogout} style={{ color: '#ff6b7b' }} title="Fazer Logout">
          <LogOut size={18} />
          <span className="admin-sidebar__tab-text">Sair</span>
        </button>

        {/* Toggle Button */}
        <button 
          className="admin-sidebar__toggle" 
          onClick={toggleSidebar} 
          title={sidebarExpanded ? "Recolher Menu" : "Expandir Menu"}
          style={{ alignSelf: 'center' }}
        >
          {sidebarExpanded ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
        </button>
      </div>
    </aside>
  );
}
